module.exports = __webpack_public_path__ + "static/media/red.c1aa2627.png";